module.exports = __webpack_public_path__ + "static/media/wild-map-on.3c6f5edd.png";